<!--component html goes here -->
<!-- Hero Start -->
<app-header></app-header>
  
<section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/foods.jpeg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
          <!-- <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> {{modelObject.nameEn}} </h4>
              </div>
          </div>  -->
          <!--end col-->
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a routerLink="/foods">Foods</a></li>
                  <li class="breadcrumb-item"><a >Food Details</a></li>
              </ul>
          </nav>
      </div>
  </div> <!--end container-->
</section><!--end section-->
  <!--end section-->
  <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!-- Hero End -->
  
  <section class="section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-5" > 
        
          <ngb-carousel id="customer-testi" [options]="customOptions">
            <ng-template ngbSlide *ngFor="let item of files">
              <div class="tiny-slide">                                
                 <img src="{{item.imageURL}}" class="d-block w-100" height="500px" width="100%" alt="...">
              </div>
            </ng-template>
          </ngb-carousel>
          <!-- <owl-carousel-o id="customer-testi" [options]="customOptions">
            <ng-template carouselSlide *ngFor="let item of files">
              <div class="tiny-slide" >
                <div class="tiny-slide"><img src="{{item.imageURL}}" 
                  height="500px" width="100%"alt=""></div>
              </div>
            </ng-template>
          </owl-carousel-o> -->
        </div>
        <div class="col-md-7 mt-4 mt-sm-0 pt-2 pt-sm-0">
          <div class="section-title ms-md-4">
            <h4 class="title">{{modelObject.nameEn}}</h4>
            <ul class="media-list list-unstyled mb-0">
              <li > <ngb-rating [max]="5" [(rate)]="modelObject.averageStar" [readonly]="true" style="font-size: 25px;">
              </ngb-rating>
            </li>
            </ul>
            <h5 class="mt-4 py-2">Overview :</h5>
            <p class="text-muted">{{modelObject.descriptionEn}}</p>
            <h5 class="mt-4 py-2">Ingredients :</h5>
  
            <ul class="list-unstyled text-muted">
              <li class="mb-0" *ngFor="let item of IngredientsList"><span class="text-primary h5 me-2" ><i class="uil uil-check-circle align-middle"></i></span>
                {{item.ingredientNameEn}}</li>
            </ul>
  
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-100 mt-60">
      <div class="row">
        <div class="col-12">
          <ul ngbNav #nav="ngbNav"
            class="nav nav-pills shadow flex-column flex-sm-row d-md-inline-flex mb-0 p-1 rounded position-relative overflow-hidden"
            id="pills-tab" role="tablist">
            <li ngbNavItem class="nav-item m-1">
              <a ngbNavLink class="nav-link py-2 px-5 rounded">
                <div class="text-center">
                  <h6 class="mb-0">Description</h6>
                </div>
              </a>
              <ng-template ngbNavContent>
                <div class="row">
                  <p class="text-muted mb-0">{{modelObject.descriptionEn}}.</p>
                  
                </div>
              </ng-template>
            </li>
         
            <li ngbNavItem class="nav-item m-1">
              <a ngbNavLink class="nav-link py-2 px-5 rounded">
                <div class="text-center">
                  <h6 class="mb-0">Review</h6>
                </div>
              </a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="card border-0 rounded shadow">
                      <ngx-simplebar style="max-height: 360px;">
                        <ul class="media-list list-unstyled mb-0">
                            <li class="mt-4" *ngFor="let item of EvaluationFoodList">
                              <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center">
                                  <a class="pe-3" href="javascript:void(0)">
                                    <img src="assets/images/client/01.jpg" class="img-fluid avatar avatar-md-sm rounded-circle shadow"
                                      alt="img">
                                  </a>
                                  
                                  <div class="flex-1 commentor-detail">
                                    <h6 class="mb-0"><a href="javascript:void(0)" class="text-dark media-heading">Lorenzo Peterson</a>
                                    </h6>
                                    <small class="text-muted">{{item.date|date:'dd/MM/yyyy hh:MM'}}</small>
                                  </div>
                                </div>
                                <a >
                                <ngb-rating [max]="5" [(rate)]="item.numberOfStars" [readonly]="true" style="font-size: 30px;"> </ngb-rating>
                              </a>
                              </div>
                              <div >
                                <div class="mt-3 text-muted p-3 bg-light rounded">
                                  <div class="row">
                                    <div class="col-md-9">
                                      <p  >{{item.comment}}
                                      </p>
                                    </div>
                                    <div class="col-md-3">
                                      <a  href="javascript:void(0)" data-bs-toggle="modal" (click)="setCommentId(item.id)" data-bs-target="#LoginForm" class="btn btn-primary ms-md-4" style="width: 77px; height: 30px; font-size: 10px;"> Report</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                        </ul>
                      </ngx-simplebar>
                    </div>
                  </div>
                  <div class="col-lg-6 mt-4 mt-lg-0 pt-2 pt-lg-0">
                    <form class="mt-3">
                        <div class="row">
                            <div class="col-6">
                                <h5>Add your review:</h5>
                              </div>
                          <div class="col-md-12">
                            <div class="mb-3">
                              <label class="form-label">Your Comment</label>
                              <div class="form-icon position-relative">
                                <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                                <textarea id="message" placeholder="Your Comment" rows="5" name="message"
                                  class="form-control ps-5" required="" [(ngModel)]="myComment"></textarea>
                              </div>
                              <div >
                                <ngb-rating  [max]="5" [(rate)]="myStars" [readonly]="false"></ngb-rating>
                              </div>
                              <div>
                                
                              </div>
                            </div>
                          </div>
                        
          
                          <div class="col-md-12">
                            <div class="send d-grid">
                              <button type="submit" class="btn btn-primary" (click)="Save()">Comment</button>
                            </div>
                          </div>
                        </div>
                      </form>
                  
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="col-12 tab-content mt-5"></div>
        </div>
      </div>
    </div>
  </section>
  <!--end section-->
  <div *ngIf="ReportForm" class="modal fade" id="LoginForm" tabindex="-1" aria-labelledby="LoginForm-title" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
            <div class="modal-header border-bottom">
                <h5 class="modal-title" id="LoginForm-title">Send Report</h5>
                <button type="button" class="btn btn-icon btn-close" data-bs-dismiss="modal" id="close-modal"><i class="uil uil-times fs-4 text-dark"></i></button>
            </div>
            <div class="modal-body">
              <h3 class="modal-title" id="LoginForm-title">Your Report</h3>
                <div class="bg-white p-3 rounded box-shadow">
                  <div class="row">
                    <textarea class="text-muted mb-0" rows="6" [(ngModel)]="message"> </textarea>                                                        
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closebutton id="closebutton">Close</button>
                <button type="button" class="btn btn-primary" (click)="SendReport()">Send</button>
            </div>
        </div>
    </div>
</div>
  <!-- Back to top -->
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
  <!-- Back to top -->